import { useEffect, useRef } from 'react';
import { io, Socket } from 'socket.io-client';
import { useAuth } from '../../auth/AuthContext.js';

let socket: Socket | null = null;

export function getSocket(): Socket | null {
  return socket;
}

export function useSocket() {
  const { token } = useAuth();
  const socketRef = useRef<Socket | null>(null);

  useEffect(() => {
    if (!token) return;

    if (!socket) {
      socket = io('/', { auth: { token }, transports: ['websocket', 'polling'] });
      socket.on('connect', () => {});
      socket.on('disconnect', () => {});
    }

    socketRef.current = socket;

    return () => {
      // Don't disconnect on unmount - keep alive
    };
  }, [token]);

  return socketRef.current;
}

export function useSocketEvent(event: string, handler: (data: any) => void) {
  const sock = useSocket();
  useEffect(() => {
    if (!sock) return;
    sock.on(event, handler);
    return () => { sock.off(event, handler); };
  }, [sock, event, handler]);
}
